import React, {useState, useEffect} from 'react'
import AdminWrapper from "../../theme/wrappers/AdminWrapper";
import FormModal from "../../theme/modals/FormModal";
import validators from "../../../utils/forms/validators";
import {nullBooleanSelect} from "../../../utils/forms/preconfiguredInputs";
import Input from "../../theme/forms/Input";
import api from "../../../store/api";
import {addErrorAlert, addLoadingAlert, addSuccessAlert} from "../../../store/calls/alertLoadingDispatch";
import {updateSiteStyleVariables} from "../../../utils/subdomains/configHandlers";

import {getSubdomain} from "../../../utils/general";
import PaginatedTable from "../../theme/tables/PaginatedTable";
import BaseModal from "../../theme/modals/BaseModal";
import SelectByCategory from "../../theme/forms/SelectByCategory";
import ConfirmModal from "../../theme/modals/ConfirmModal";
import NoResultsBox from "../../theme/cards/NoResultsBox";
import isUserAdmin from "../../../utils/session/perms";
import settings from "../../../settings";
import {setLoading} from "../../../store/actions/states";
import {toggleGlobalLoader} from "../../../store/actions/session";
import formatters from "../../../utils/forms/formatters";
import EmbedCodeGenerator from '../../subcomponents/admin/EmbedCodeGenerator';


const configInputs = [
    {
        type: "text",
        label: "Support Phone Number",
        subLabel: "Leave blank to default to CleanFi suppoort",
        dataKey: "contact-phone",
    },
    {
        type: "text",
        label: "Support Email",
        subLabel: "Leave blank to default to CleanFi suppoort",
        dataKey: "contact-email",
    },
    {
        type: 'hex_color',
        label: "Primary Color",
        dataKey: "primary-color",
        ...validators.isValidHex
    },
    {
        type: 'hex_color',
        label: "Secondary Color",
        dataKey: "secondary-color",
        ...validators.isValidHex
    },
    {
        type: 'hex_color',
        label: "Success Color",
        dataKey: "success-color",
        ...validators.isValidHex
    },
    {
        type: 'hex_color',
        label: "Warning Color",
        dataKey: "warning-color",
        ...validators.isValidHex
    },
    {
        type: 'hex_color',
        label: "Danger Color",
        dataKey: "danger-color",
        ...validators.isValidHex
    },
    {
        type: 'text',
        label: "Landing Page Title",
        dataKey: "homepage-title",
    },
    {
        type: 'text',
        label: "Landing Page SubTitle",
        dataKey: "homepage-subtitle",
    },
    {
        type: 'text',
        label: "Organization Home Page Link",
        subLabel: "A valid URL that redirects to your organization's homepage. Must be fully formed, like 'https://www.cleanfi.com'",
        dataKey: "org-home-link",
    },
    {
        type: 'file',
        label: "Landing Page Background",
        dataKey: "homepage-bg",
        public: true,
    },
    {
        type: 'file',
        label: "Logo for Dark Background",
        dataKey: "logo-light-src",
        public: true,
        ...validators.isStringOfMinLength(3)
    },
    {
        type: 'file',
        label: "Logo for Light Background",
        dataKey: "logo-dark-src",
        public: true,
    },
    {
        type: 'news_links',
        label: "News to show in the landing page",
        subLabel: "Change the default news message and link (optional)",
        dataKey: "news-links",
        public: true
      },

]



function SubdomainConfigScreen({...props}) {

    const [displayedData, setDisplayedData] = useState({})
    const [mode, setMode] = useState('widget') // styles, funders, widget, admins
    const [productModalVisible, setProductModalVisible] = useState(false);
    const [confirmResetVisible, setConfirmResetVisible] = useState(false);
    const [confirmRemoveAdminVisible, setConfirmRemoveAdminVisible] = useState(false);
    const [modalContext, setModalContext] = useState({})
    const [productsData, setProductsData] = useState([])
    const [widgetCode, setWidgetCode] = useState('')
    const [subdomainAdminData, setSubdomainAdminData] = useState([]);
    const [subdomainAdminCreateModalOpen, setSubdomainAdminCreateModalOpen] = useState(false);
    const [userFormModalData, setUserFormModalData] = useState({});

    const curr_subdomain = getSubdomain() ||"app"

    const pullSubdomainConfigs = () => {

        return api.get(`/subdomain-configs/${curr_subdomain}`)
            .then((res) => {
                setDisplayedData(res.data?.config || {})
            })
    }



    const updateSubdomainConfigs = (data = {}) => {
        return api.patch(`/subdomain-configs/${curr_subdomain}/`, {...displayedData,  ...(data || {})})
            .then((res) => {
                setDisplayedData(res.data?.config || {})
                updateSiteStyleVariables(displayedData)
                addSuccessAlert("Configuration Updated")
            })
            .catch(() => {
                addErrorAlert("Configuration update failed")
            })
            // .finally(() => removeLoadingAlert())
    }



    useEffect(() => {
        pullSubdomainConfigs();
        getProducts();
    }, [])


    const getProducts = () => {
        return api.get('/loan-products/')
            .then(res => setProductsData(res.data.map(d => ({...d, funder_name: d.funder?.name}))))
    }


    const getWidgetHTMLCode = () => {
        toggleGlobalLoader(true)
        api.get("/get-widget/", {s: getSubdomain()})
            .then((res) => {
                 setWidgetCode(res.data)
            })
            .catch(() => addErrorAlert("unable to load widget"))
            .finally(toggleGlobalLoader(false))
    }

    const getSubdomainAdmins = () => {
          toggleGlobalLoader(true);
          return api.get('/get-subdomain-admins')
              .then((res) => setSubdomainAdminData(res.data))
              .catch((e) => {
                  console.error(e)
                  addErrorAlert("Administrator data failed to laod")
              })
              .finally(() => toggleGlobalLoader(false))
    }

    const updateUserSubdomainStatus = (data) => {
         toggleGlobalLoader(true);
         return api.post("/user-subdomain-admin/", data)
             .then((res) => {
                 // view returns updated list of admins
                 setSubdomainAdminData([...res.data]);
                 addSuccessAlert(`Success`)
                 setSubdomainAdminCreateModalOpen(false)
             })
             .catch((err) => {
                    if (err.response.status === 404) {
                        setModalContext({...modalContext, error: "That user does not exist."})
                    } else {
                        setModalContext({...modalContext, error: "That didn't work. Please try again."})
                    }
             })
             .finally(() => toggleGlobalLoader(false))
    }


    const handleAddProductModal = () => <></>

    function NewsLinksEditor({ value, onChange, label = "News", subLabel }) {
        // value es la cadena semicolon-delimited del backend
        const parseValue = (val) => {
          if (!val || typeof val !== "string") return [{ text: "", url: "" }];
          const items = val.split(";").map(s => s.trim()).filter(Boolean);
          const rows = items.map(s => {
            const [text = "", url = ""] = s.split("|").map(x => (x || "").trim());
            return { text, url };
          });
          return rows.length ? rows : [{ text: "", url: "" }];
        };
      
        const serialize = (rows) => {
          const cleaned = rows
            .map(r => ({ text: r.text?.trim() || "", url: r.url?.trim() || "" }))
            .filter(r => r.text || r.url); // no guardar filas totalmente vacías
          return cleaned.map(r => `${r.text}|${r.url}`).join("; ");
        };
      
        const [rows, setRows] = React.useState(parseValue(value));
      
        // sincróniza hacia afuera cuando cambie rows
        useEffect(() => {
          onChange(serialize(rows));
        }, [rows]); // eslint-disable-line react-hooks/exhaustive-deps
      
        const updateRow = (i, key, val) => {
          const copy = [...rows];
          copy[i] = { ...copy[i], [key]: val };
          setRows(copy);
        };
      
        const addRow = () => setRows([...rows, { text: "", url: "" }]);
        const removeRow = (i) => setRows(rows.filter((_, idx) => idx !== i));
      
        return (
          <div className="field">
            <label className="label">{label}</label>
            {subLabel && <p className="help">{subLabel}</p>}
            <div className="box">
              {rows.map((row, i) => (
                <div key={i} className="columns is-mobile is-vcentered mb-2">
                  <div className="column">
                    <input
                      className="input"
                      type="text"
                      placeholder="Texto de la noticia"
                      value={row.text}
                      onChange={(e) => updateRow(i, "text", e.target.value)}
                    />
                  </div>
                  <div className="column">
                    <input
                      className="input"
                      type="url"
                      placeholder="https://enlace.com"
                      value={row.url}
                      onChange={(e) => updateRow(i, "url", e.target.value)}
                    />
                  </div>
                  <div className="column is-narrow">
                    <button
                      type="button"
                      className="button is-light"
                      onClick={() => removeRow(i)}
                      title="Eliminar"
                    >
                      ✕
                    </button>
                  </div>
                </div>
              ))}
              <button type="button" className="button is-link is-light" onClick={addRow}>
                + Añadir noticia
              </button>
            </div>
          </div>
        );
      }

    const renderLoanProductsDisplay = () => {
        // console.log(this.state.specInstance)

        const loan_products = productsData.filter(d => (displayedData?.loan_products || []).includes(d.id))

        if (!loan_products.length) {
            return <NoResultsBox/>
        }


        // sort into funders
        const sort_by_funder = {}

        loan_products.forEach(d => {
            sort_by_funder[d.funder.id] = [...(sort_by_funder[d.funder.id] || []), d]
        })



        const funderCards = Object.keys(sort_by_funder).map((funder_id,i) => {
            let data_arr = sort_by_funder[funder_id]
            let funder_data = data_arr[0].funder
            if (!data_arr.length) return <></>
            return (
                <div key={funder_id} className="box">

                    <h4 className="is-size-4 has-text-primary">{funder_data.name}</h4>
                    <p className="is-size-6 is-italic">{funder_data.description}</p>

                    {!!data_arr.length &&

                        <div className="mt-4">
                            <h6 className="is-size-7 has-text-grey-light">Available Products</h6>
                            {data_arr.map(l => {
                                return (
                                    <p>{l.name}</p>
                                )
                            })}

                        </div>
                    }

                </div>
            )
        });


        return (
            <>
                {funderCards}
                <div className="my-4 is-size-7 has-text-grey mx-auto">
                    <p className="has-text-centered">Program Manager: if you see a funder that you have not approved for your program, kindly notify
                        <a href='mailto:admin@cleanfi.com'> admin@cleanfi.com</a>, or contact the funder directly and ask them to qualify.</p>
                </div>
            </>
        )
    };



    const subIsProductSpecific = () => {
        return (displayedData?.loan_products || []).length
    }



    return (
        <AdminWrapper>
            <div className="section">
                <div className="container is-fullhd mx-6">
                    <div className="level mb-6">
                        <div className="level-left">
                            <div className="level-item">
                                <h2 className="title is-2 is-info">Sudomain Config for: {curr_subdomain}</h2>
                            </div>
                        </div>
                        
                    </div>


                    <div className="tabs is-medium ">
                        <ul>
                            <li
                                className={mode === 'styles' ? 'is-active' : ''}
                                onClick={() => setMode('styles')}
                            >
                                <a>Styles</a>
                            </li>
                            {isUserAdmin() && <li
                                className={mode === 'funders' ? 'is-active' : ''}
                                onClick={() => setMode('funders')}
                            >
                                <a>Funders</a>
                            </li>}
                            <li
                                className={mode === 'widget' ? 'is-active' : ''}
                                onClick={() => {
                                    setMode('widget')
                                    getWidgetHTMLCode();
                                }}
                            >
                                <a>Widget</a>
                            </li>
                            <li
                                className={mode === 'admins' ? 'is-active' : ''}
                                onClick={() => {
                                    setMode('admins')
                                    getSubdomainAdmins();
                                }}
                            >
                                <a>Administrators</a>
                            </li>
                        </ul>
                    </div>


                    {mode === "styles" &&
                        <>

                            {/* <h4 className={'title'}>Styles</h4> */}
                            <h5 className="subtitle has-text-primary mt-2">Set colors and background images for your subdomain.</h5>

                            {configInputs.map(d => (
                                    <Input key={d.dataKey}
                                           {...d}
                                           value={displayedData[d.dataKey] || ''}
                                           onChange={(val) => setDisplayedData({...displayedData, [d.dataKey]: val})}
                                           onUploadSuccess={d.type === 'file' ? (file) => setDisplayedData({...displayedData, [d.dataKey]: file.fileUploadUrl}) : null}
                                    />
                                ))
                            }

                            <div className="is-flex is-justify-content-flex-end">
                             <a className="button is-success is-medium "
                                onClick={e => updateSubdomainConfigs()}
                             >
                                 Update
                             </a>
                            </div>
                        </>
                    }

                    {mode === "funders" &&
                        <>
                            <div className="level">
                                <div className="level-left">
                                    <div className="level-item">
                                        {subIsProductSpecific() ?
                                            <h4 className="subtitle mr-3">Funders and loan products currently available on this subdomain.</h4> :
                                            <h4 className="subtitle mr-3">Your subdomain currently returns all available loan products for a project.</h4>
                                        }
                                    </div>
                                </div>
                                <div className="level-right">
                                    <button className='button is-link' onClick={() => setProductModalVisible(true)}>
                                        {subIsProductSpecific() ? "+ Add Products" : "Narrow Domain to Select Products"}
                                    </button>
                                    {!!subIsProductSpecific() &&
                                        <button className='button is-link ml-5' onClick={() => setConfirmResetVisible(true)}>
                                            Reset -- make all products available
                                        </button>
                                    }
                                </div>
                            </div>


                            {!!subIsProductSpecific() && renderLoanProductsDisplay()}
                        </>
                    }

                    {mode === 'widget' &&
                        <>
                            <p className='is-size-4 mb-4'>Embed Code</p>
                            <p className='mb-4'>CleanFi offers an embeddable form that is easy to drop into your own website. This form takes
                                clients directly into the project creation process on your subdomain.
                            </p>
                            <EmbedCodeGenerator
                                subdomain={curr_subdomain}
                                primaryColor={displayedData['primary-color']}
                            />
                        </>
                    }

                    {mode === 'admins' &&
                        <>

                            <div className="is-flex is-justify-content-space-between">
                                <h3 className='has-text-primary subtitle'>Subdomain Administrators</h3>
                                <button
                                    className="button is-primary"
                                    onClick={() => setSubdomainAdminCreateModalOpen(true)}
                                >
                                     + Add Administrator
                                </button>

                            </div>
                            <div className="columns is-multiline">

                                {subdomainAdminData.map(admin => (
                                    <div className="column is-half">
                                        <div className="card my-4">
                                            <div className="card-content">
                                                <p className="has-text-primary">{admin.first_name} {admin.last_name}</p>
                                                <p>{admin.email}</p>
                                                <p>last login: {formatters.date().formatter(admin.last_login)}</p>
                                            </div>
                                            <div className='card-footer'>
                                                <div className="card-footer-item">
                                                    <a onClick={() => {
                                                             setModalContext(admin);
                                                             setConfirmRemoveAdminVisible(true);
                                                        }}
                                                       className="has-text-danger"
                                                    >
                                                        <i className="far fa-times-circle mr-3"/>
                                                        Remove
                                                    </a>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))

                                }
                            </div>
                        </>
                    }


                </div>

                <BaseModal
                    visible={productModalVisible}
                    cardStyle={{width: 640, height: 800,  display: 'flex', justifyContent: 'center'}}
                >
                    <h5 className="title is-5">Select Displayable Loan Products for your Subdomain </h5>
                    <SelectByCategory
                        data={productsData.map(d => ({
                            ...d, funder_name: d.funder?.name, selected: (displayedData?.loan_products || []).includes(d.id)
                        }))}
                        categoryKey="funder_name"
                        onOptionValueChange={(selected, id) => {
                            let new_lp_list = (displayedData.loan_products || [])
                            if (selected) {
                                new_lp_list.push(id)
                            } else {
                                new_lp_list = new_lp_list.filter(d => d !== id)
                            }
                            setDisplayedData({...displayedData, loan_products: new_lp_list})
                        }}
                    />
                    <button className='button is-primary' onClick={() => {
                        updateSubdomainConfigs()
                            .then(() => {
                                setProductModalVisible(false)
                            })

                    }}>Close</button>
                </BaseModal>

                <ConfirmModal
                    type="warning"
                    visible={confirmResetVisible}
                    prompt={"This will remove all associated loan products with this subdomain, " +
                        "and all applicable loan products will appear when someone searches. Is this what you want to do?."}
                    onCancel={() => setConfirmResetVisible(false)}
                    onAccept={() => {
                        const newDataDisplay = {...displayedData, loan_products: []}
                        updateSubdomainConfigs(newDataDisplay)
                            .then(() => setConfirmResetVisible(false))
                    }}
                />

                <ConfirmModal
                    type="warning"
                    visible={confirmRemoveAdminVisible}
                    prompt={`Are you sure you want to remove ${modalContext.email} as an admin of this subdomain?`}
                    onCancel={() => {
                        setConfirmRemoveAdminVisible(false)
                        setModalContext({})
                    }}
                    onAccept={() => {
                        updateUserSubdomainStatus({user_email: modalContext.email});
                        setConfirmRemoveAdminVisible(false)
                        setModalContext({})
                    }}
                />

                {/* Make User Admin Modal */}
                <FormModal
                    title="Add an admin to this subdomain"
                    visible={subdomainAdminCreateModalOpen}
                    inputs={[{
                        type: 'text',
                        label: 'Existing user email',
                        value: modalContext.email,
                        dataKey: 'email',
                        ...validators.isEmail,
                    }]}
                    // reset={this.state.editModalReset}
                    disableAutocomplete
                    onSubmit={(data) => {
                        setModalContext({...modalContext, email: data.email, error: null})
                        updateUserSubdomainStatus({user_email: data.email})


                    }}
                    onCancel={() => {
                        setModalContext({});
                        setSubdomainAdminCreateModalOpen(false);
                    }}
                >
                    <p>
                        This must be an existing Cleanfi account. New accounts can be created at
                        <a href='https://cleanfi.com/create-account'> https://cleanfi.com/create-account</a>.
                        All admins have equivalent permissions. They may view projects that come through the subdomain,
                         change configurations, and add/remove other admins.
                    </p>
                    {!!modalContext.error &&
                        <p className="has-text-danger my-4 has-text-weight-semibold">
                            {modalContext.error}
                        </p>
                    }
                </FormModal>

            </div>
        </AdminWrapper>
    )
}


export default SubdomainConfigScreen;

